import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'numberTruncated',
	standalone: false,
})
export class NumberTruncatedPipe implements PipeTransform {
	transform(value: number, currency: string): string {
		if (isNaN(value) || value === null || value === 0) return '';

		let absValue = Math.abs(value);
		let result = '';

		if (absValue >= 1000000) {
			// keep 1 decimal place
			result = Math.trunc((absValue / 1000000) * 10) / 10 + 'M';
		} else if (absValue >= 1000) {
			// keep 1 decimal place
			result = Math.trunc((absValue / 1000) * 10) / 10 + 'k';
		} else {
			// keep 2 decimal place
			result = Math.trunc(absValue * 100) / 100 + '';
		}

		return currency + result;
	}
}
